import SearchRequest from '@wwdev/product/SearchRequest';
import Filters from '@wwdev/product/filters';
import Masonry from "../../../externals/masonry/masonry";
import Sliders from "../Sliders";

class CustomFilters extends Filters {
	constructor() {
		super();
		new Sliders();
	}

	initEventListeners() {
		super.initEventListeners();

		$(this.config.filters).off('.product')
			.on('change.product', '[data-filter-select]', this.handleSelectFilterChange.bind(this))
			.on('change.product', '[name="min_price"]', this.changePrice.bind(this))

		$(document).off('.product')
			.on('submit.product', '[data-scope="product-search"]', this.setQ.bind(this))
	}

	handleSelectFilterChange(e) {
		let $select = $(e.currentTarget);
		let filterData = JSON.parse($select.val());

		if (SearchRequest.hasFilterGroup(filterData.tree_id)) {
			SearchRequest.clearFilter(filterData.tree_id, filterData.id);
			delete SearchRequest.request.filter[filterData.tree_id]
		}

		if(filterData.id) {
			SearchRequest.addFilter(filterData.tree_id, filterData.id, filterData.title_seo)
		}

		SearchRequest.setPage(1);

		this.reload()
	}

	afterCallback() {
		super.afterCallback();
		new Masonry();
		new Sliders();
	}

	changePrice(e) {
		let $input = $(e.currentTarget);
		let $scope = $input.closest('[data-price-sliders]');
		let $min = $scope.find('[name="min_price"]');
		let $max = $scope.find('[name="max_price"]');
		SearchRequest.setByKeyValue('min_price', $min.val());
		SearchRequest.setByKeyValue('max_price', $max.val());
		this.reload();
	}

	setQ(e) {
		e.preventDefault();
		let $form = $(e.currentTarget);
		SearchRequest.setByKeyValue('q', $form.find('[name="q"]').val());
		this.reload();
	}

	resetScroll() {
		$([document.documentElement, document.body]).animate({
			scrollTop: 0
		}, 250);
	}
}

export default CustomFilters;